<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:34:09
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id='main-container' class='evaluate main-container'>
                <div v-for='(item,index) in productData.memberOrderItemList' :key='item.id'>
                    <div class='evaluateBox'>
                        <div>
                            <img :src="item.productImg" alt="" class='commodityImg'>
                            <p>
                                <span class='ms'>综合评价</span>
                                <van-rate v-model="item.quantity" :size="24" :count="5" color="#EE2E50" void-color="#000;" @change='changeRate(item,$event)' />
                            </p>
                            <p class='pText'>{{item.rateText}}</p>
                        </div>
                    </div>
                    <div class='textStyle'>
                        <van-cell-group>
                            <van-field v-model="item.message" type="textarea" placeholder="宝贝满足你的期待吗？说说它的优点和美中不足的地方吧" rows="4" :autosize='autosize' :maxlength="150" @input="onInput" />
                        </van-cell-group>
                    </div>
                    <div class='bgWhite'>
                        <!-- <template>
                            <wo-template-cell-group :dataSource="urlData" v-model="value[index]">
                            </wo-template-cell-group>
                        </template> -->
                        <es-photo-album
                            :title="title"
                            :label="label"
                            :data-source="dataSource"
                            :is-disabled="isDisabled"
                            :max-count="maxCount"
                            :other-data="getOtherData(index)"
                            :origin="origin"
                            :save="save"
                            :size-type="sizeType"
                        />
                    </div>
                </div>
                <div class='btnStyle'>
                    <van-button round type="danger" @click='releaseEva'>发布</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Dialog, Toast, Field } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    components: {
        Dialog,
        Toast,
        Field
    },
    data() {
        return {
            headerImg: require('../assets/img/myCenter/header.png'),
            valuerate: 5,
            autosize: { minHeight: 50 },
            value: [],
            urlData: [
                {
                    name: '',
                    type: 8,
                    enName: 'environmentPhoto',
                    fieldLength: 5
                }
            ],
            productData: {},
            params: {

            },
            title: '',
            label: '',
            dataSource: [],
            isDisabled: false,
            maxCount: 4,
            otherData: {},
            origin: ['camera', 'album'],
            save: true,
            sizeType: 'default'
        };
    },
    esvReady() {
        const self = this;
        this.ESVStorage.getSavedValue('productData', (data) => {
            self.productData = data;
            this.productData.memberOrderItemList.forEach(function(
                value,
                index,
                array
            ) {
                value.quantity = 5;
                value.rateText = '非常好';
                self.value.push({});
            });
        });
    },
    esvShow() {
        document.title = '发表评价';
    },
    methods: {
        // 上传图片前回调
        // beforeAction() {
        //     console.log('上传');
        // },
        getOtherData(index) {
            return {
                index
            };
        },
        onInput(e) {
            if (e.length >= 150) {
                console.log(111);
                Toast('评论内容最大长度为150');
            }
        },
        releaseEva() {
            console.log(this.dataSource);

            const ths = this;
            ths.dealData();
            ths.$doRequest(
                {
                    url: '/comment/saveProductComment',
                    params: ths.params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    Toast.success('评价成功');
                    ths.esvOpenPage('OPCommentSuccess');
                }
            );
        },
        // 处理数据
        dealData() {
            const ths = this;
            let obj = {};
            let orderCode = '';
            const objArr = [];
            const imageObj = ths.dealImageModel(ths.dataSource);
            ths.productData.memberOrderItemList.forEach(function(
                value,
                index,
                array
            ) {
                obj = {
                    productId: value.productId,
                    skuCode: value.skuCode,
                    content: value.message,
                    quantity: value.quantity,
                    commentImage: ths.dealPhoto(
                        imageObj[index]
                    )
                };
                objArr.push(obj);
                orderCode = value.orderCode;
            });
            ths.paramsString = JSON.stringify(objArr);
            // 照片提前存储
            ths.params = {
                orderCode: orderCode,
                productCommentJsonList: ths.paramsString
            };
        },
        // 处理图片数据
        dealPhoto(photoObj) {
            const newPhone = [];
            if (photoObj) {
                if (photoObj) {
                    // 表示新增的数据
                    photoObj.forEach((item, index) => {
                        newPhone.push(item.photoUrl);
                    });
                } else {
                    // Sting类型的表示编辑的数据
                    return photoObj;
                }
            }
            console.log(newPhone.join(','));
            return newPhone.join(',');
        },
        dealImageModel(imageModel) {
            const imageObj = {};
            imageModel.forEach((item) => {
                const index = item.otherData.index;
                if (!imageObj[index]) {
                    imageObj[index] = [];
                }
                imageObj[index].push(item);
            });
            return imageObj;
        },
        changeRate(item, rate) {
            switch (rate) {
            case 5:
                item.rateText = '非常好';
                break;
            case 4:
                item.rateText = '好';
                break;
            case 3:
                item.rateText = '一般';
                break;
            case 2:
                item.rateText = '差';
                break;
            case 1:
                item.rateText = '非常差';
                break;

            default:
                break;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.btnStyle {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 50px;
    .van-button {
        width: 80%;
    }
    .van-button--danger {
        background: #ee2e50;
        border: 1px solid #ee2e50;
    }
}
.bgWhite {
    background: #fff;
    padding: 8px 12px;
    // /deep/.es-photo-album .deletePhoto {
    //     color: #EE2E50;
    // }
}
.evaluate {
    .evaluateBox {
        background: #fff;
        padding: 12px;
        overflow: hidden;
        .commodityImg {
            width: 50px;
            height: 50px;
            float: left;
        }
        p {
            float: left;
            padding-top: 10px;
            .ms {
                float: left;
                margin: 4px 10px;
            }
            .van-rate {
                float: left;
            }
            .my {
                float: right;
                margin-left: 50px;
                color: #bebec5;
            }
        }
    }
}
.pText {
    float: right;
    color: #bebec5;
    margin-top: 3px;
    margin-left: 5px;
}
.textStyle /deep/ .van-cell{
    padding: 10px 12px;
}
</style>
<style lang="scss">
    #page_Container .es-photo-album .deletePhoto {
        color: #EE2E50;
    }
</style>
